import { FormControl, FormControlProps, InputLabel, Select, SelectProps } from '@mui/material';
import { Control, Controller, FieldPath, FieldValues, RegisterOptions } from 'react-hook-form';

type OwnProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>> = {
    name: TName;
    control: Control<TFieldValues>;
    formControlProps?: FormControlProps;
    rules?: Omit<RegisterOptions<TFieldValues, TName>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>;
} & SelectProps;

export function FormSelect<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
    name,
    label,
    control,
    children,
    formControlProps,
    fullWidth,
    rules,
    ...props
}: OwnProps<TFieldValues, TName>) {
    const labelId = `${name}-label`;

    const fw = fullWidth ?? true;
    return (
        <FormControl {...(formControlProps ?? {})} fullWidth={fw}>
            <InputLabel id={labelId}>{label}</InputLabel>
            <Controller
                name={name}
                control={control}
                rules={rules}
                render={({ field, fieldState: { error } }) => (
                    <Select
                        labelId={labelId}
                        {...field}
                        {...props}
                        label={label}
                        error={!!error}
                        variant="standard"
                        fullWidth={fw}
                    >
                        {children}
                    </Select>
                )}
            />
        </FormControl>
    );
}
